import type { SeoContent } from 'lib/utils/seo/types';

type PlaceholderOptions = {
  tokenisedString: string;
  categoryLabel?: string;
  location?: string;
  totalResults?: number;
};

export const replacePlaceholders = ({
  tokenisedString,
  categoryLabel,
  location,
  totalResults,
}: PlaceholderOptions) => {
  return tokenisedString
    .replace(/\[location\]/gi, location ?? '')
    .replace(/\[total_results\]/gi, totalResults?.toString() ?? '0')
    .replace(/\[category\]/gi, categoryLabel ?? '')
    .replace(/%location%/gi, location ?? '')
    .replace(/%total_results%/gi, totalResults?.toString() ?? '0')
    .replace(/%category%/gi, categoryLabel ?? '');
};

type HeadingOptions = {
  seoContent?: SeoContent;
  categoryLabel?: string;
  location?: string;
  totalResults?: number;
};

export const getHeading = ({
  seoContent,
  categoryLabel,
  location,
  totalResults,
}: HeadingOptions = {}) => {
  if (seoContent?.heading) {
    return replacePlaceholders({
      tokenisedString: seoContent.heading,
      categoryLabel: categoryLabel,
      location,
      totalResults,
    });
  } else if (categoryLabel && location) {
    return `${categoryLabel} in ${location} ${!!totalResults && `(${totalResults})`}`;
  } else if (!!totalResults) {
    return `(${totalResults})`;
  }
};
